export const fetchRequestBuilder =
    ({
        apiHost,
        backendFlags,
        apiRequestsRecords,
    }: {
        apiHost: string
        backendFlags?: string
        apiRequestsRecords?: string[]
    }) =>
    <T>(url: string, config: RequestInit = {}) => {
        if (typeof apiHost === 'undefined') {
            throw new Error('No apiHost was defined for requests')
        }

        const [baseUrl, queryString] = url.split('?')
        const params = new URLSearchParams(queryString)

        if (backendFlags) {
            params.set('flags', backendFlags)
        }

        apiRequestsRecords?.push(`${baseUrl}?${params}`)

        return fetch(`${apiHost}${baseUrl}?${params}`, {
            headers: {
                'content-type': 'application/json',
            },
            ...config,
        }).then(async (resp) => {
            const bodyText = await resp.text()

            try {
                if (resp.headers.get('content-type')?.includes('application/json')) {
                    const body = bodyText ? JSON.parse(bodyText) : null
                    if (resp.ok) {
                        return {
                            originalResponse: resp,
                            data: body,
                            errors: [],
                            bodyText,
                        }
                    }
                    return {
                        originalResponse: resp,
                        data: null,
                        errors: body?.errors || (body?.message ? [body.message] : []),
                        bodyText,
                    }
                }
                return {
                    originalResponse: resp,
                    data: bodyText as unknown as T, // should be a string
                    errors: [],
                    bodyText,
                }
            } catch (error) {
                const message = (error as Error).toString()
                return {
                    originalResponse: resp,
                    data: null,
                    errors: [message],
                    bodyText,
                }
            }
        })
    }
